import {
  newAudioPinComponent,
  newHotspotPinComponent,
  newImagePinComponent,
  newLinePinComponent,
  newShapePinComponent,
  newSize,
  newTextPinComponent,
  newTimerPinComponent,
  newVector,
  PinComponent,
} from '@lessonup/pins-shared';
import { JSONContent } from '@tiptap/core';

const orderLessDummyComponents: PinComponent[] = [
  newShapePinComponent({ position: newVector(1400, 50), settings: { fillColor: 'red' }, rotation: 200 }),
  newShapePinComponent({ position: newVector(500, 100), settings: { fillColor: 'yellow' } }),
  newShapePinComponent({ position: newVector(-50, 1000), settings: { fillColor: 'green' } }),
  newHotspotPinComponent({ position: newVector(800, 400), settings: { iconFill: 'ROCKET' } }),
  newHotspotPinComponent({ position: newVector(800, 600), settings: { iconFill: 'ADD' } }),
  newImagePinComponent({
    url: '/img/placeholder-400x400.svg',
    position: newVector(300, 40),
    size: newSize(240, 240),
  }),
  newLinePinComponent({ start: newVector(650, 550), settings: { headMarker: 'NONE', tailMarker: 'ARROW' } }),
  newLinePinComponent({
    start: newVector(650, 570),
    end: newVector(650, 670),
    settings: { headMarker: 'NONE', tailMarker: 'ARROW' },
  }),
  newLinePinComponent({ start: newVector(200, 200), end: newVector(50, 50) }),
  newTextPinComponent({ position: newVector(800, 100) }),
  newTextPinComponent({ position: newVector(1200, 100), content: bulletList() }),
  newTimerPinComponent({ position: newVector(100, 300), settings: { seconds: 10 } }),
  newAudioPinComponent({
    position: newVector(500, 400),
    settings: {
      audioUrl:
        typeof window !== 'undefined'
          ? `${window.location.protocol}//${window.location.host}/file_example_MP3_2MG.mp3`
          : '',
      title: 'Audio',
    },
  }),
];

export const dummyComponents: PinComponent[] = orderLessDummyComponents.map((component, index) => ({
  ...component,
  order: generateOrder(index),
}));

function bulletList(): JSONContent {
  return {
    type: 'doc',
    content: [
      {
        type: 'customBulletList',
        content: [
          {
            type: 'customListItem',
            content: [
              {
                type: 'paragraph',
                content: [
                  {
                    type: 'text',
                    text: 'Platform waarsssmee een docent laagdrempelig zijn lessen kan verrijken',
                  },
                ],
              },
            ],
          },
          {
            type: 'customListItem',
            content: [
              {
                type: 'paragraph',
                content: [
                  {
                    type: 'text',
                    text: 'Van presentatie naar les',
                  },
                ],
              },
            ],
          },
          {
            type: 'customListItem',
            content: [
              {
                type: 'paragraph',
                content: [
                  {
                    type: 'text',
                    text: 'Alles in een: niet schakelen tussen applicaties',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
}

function generateOrder(index: number): string {
  const base = 26; // a-z
  // 97 is 'a'
  const firstChar = String.fromCharCode(97 + Math.floor(index / base));
  const secondChar = String.fromCharCode(97 + (index % base));
  return firstChar + secondChar;
}
